export { MB_customWindowForWeb } from './src/customWindowForWeb';
export type { MB_CustomHTMLImageElement, MB_BroadcastChannel } from './src/customWindowForWeb';